import { Component, OnInit, ViewChild, Directive } from '@angular/core';
import { ClienteLogin, ClienteXCiudad } from "../../login/cliente_login";
import { correctHeight, detectBody } from "../../../app.helpers";
import { SessionStorageService } from "ngx-webstorage/dist/services";
import { HandleError } from "../../../components/common/utils/handleError.component";
import { Router } from '@angular/router';
import { SessionTokenService } from "../../../components/common/utils/sessionToken.service";
import { ContratistasService } from "./contratistas.service";
import { ContratosEntity, ContratistaEntity, ContratosExcel, BuscaContratista } from "../entities/contratistas_entity";
import { ListaDiccionaryEntity } from "../../../components/common/utils/entities/lista_dictionary_entity";
import { ConstantService } from "../../../components/common/utils/constant.service";
import { ModalComponent } from 'ng2-bs3-modal/ng2-bs3-modal';
import { UtilService } from '../../../components/common/utils/util.service';
import { FilterEstadoVehSiniestrosPipe } from '../../siniestros/siniestros-filter.component';
import { Archivo, BuscaArchivos } from '../../../components/common/utils/entities/util_entity';

const swal = require("sweetalert2");

declare var jQuery: any;
@Component({
    selector: 'contratistas',
    providers: [ContratistasService],
    templateUrl: 'contratistas.template.html',
    styleUrls: ["contratistas.style.css"]

})

export class Contratistas implements OnInit {
    showLoader: string;
    usuario: ClienteLogin;
    userEmpresa: ClienteXCiudad;
    listaContratistas: ListaDiccionaryEntity[];
    listaContratos: ContratosEntity[];
    contratista: ContratistaEntity;
    contratos: ContratosExcel;
    inicial: number;
    datosBusqueda: BuscaArchivos;
    private url = "contratistas";
    urlExportarExcel: string;
    filterQuery: string;
    filterQuery2: string;
    filterQuery3: string;
    @ViewChild('contratistaNew')
    modal: ModalComponent;
    nuevoContratista: ContratistaEntity;
    datosContratista: BuscaContratista;
    bandera: number;
    adjuntos:Archivo[];
    constructor(private contratistasService: ContratistasService,
        public utilsService: UtilService,
        private router: Router,
        private sessionTokenService: SessionTokenService,
        private handleError: HandleError,
        public sesionStorageService: SessionStorageService
    ) {
        let constantService = new ConstantService();
        this.url = constantService.API_ENDPOINT + this.url;

    }
    ngOnInit(): void {
        this.showLoader = "sk-loading";
        this.filterQuery2 = "";
        this.filterQuery3 = "";
    
        this.adjuntos=[];
        this.datosBusqueda = new BuscaArchivos();
        try {
            this.usuario = jQuery.parseJSON(this.sesionStorageService.retrieve("usuario"));
            //console.log(jQuery.parseJSON(this.sesionStorageService.retrieve("usuario")));
        } catch (e) {
            this.usuario = this.sesionStorageService.retrieve("usuario");
            //console.log(this.sesionStorageService.retrieve("usuarioEmpresa"));
        }
        if (this.usuario == null) {
            let error = { "status": 998, "message": "Acceso denegado" };
            this.handleError.redirectUrl(error)
        } else {
            let bandera = this.sessionTokenService.useJwtHelper();
            if (!bandera) {
                this.listaContratistas = new Array<ListaDiccionaryEntity>();
                this.contratista = new ContratistaEntity();
                this.nuevoContratista = new ContratistaEntity();

                try {
                    this.userEmpresa = jQuery.parseJSON(this.sesionStorageService.retrieve("usuarioEmpresa"));
                } catch (e) {
                    this.userEmpresa = this.sesionStorageService.retrieve("usuarioEmpresa");
                }
                this.CargarContratistas();
                this.sesionStorageService.observe("usuarioEmpresa").subscribe(a => {
                    try {
                        this.userEmpresa = jQuery.parseJSON(a);
                    } catch (e) {
                        this.userEmpresa = a;
                    }
                    this.CargarContratistas();

                })
            }
        }
    }

    CargarContratistas() {
        this.contratistasService.consultarListContratistas(this.userEmpresa).subscribe(contratistas => {
            this.listaContratistas = contratistas;

            if (this.listaContratistas.length > 0) {
                this.inicial = this.listaContratistas[0].Codigo;
                this.CargarContratos(this.inicial);
                this.showLoader = "";
            }

        }, error => this.handleError.redirectUrl(error));
    }

    CargarContratos(codigoContratista: number) {
        if (codigoContratista != undefined || codigoContratista != null) {
            this.contratista.CiuCod = this.userEmpresa.Ciudad;
            this.contratista.CodigoContratista = codigoContratista;
            this.contratista.CliCod=this.userEmpresa.CodigoCliente;    
            this.urlExportarExcel = this.url + '/ExportarContratos/' + this.contratista.CiuCod + '/' + this.contratista.CodigoContratista+'/'+this.contratista.CliCod;
            this.contratistasService.consultarContratos(this.contratista).subscribe(contratos => {
                this.listaContratos = contratos;
                this.showLoader = "";
            }, error => this.handleError.redirectUrl(error));
        }
    }

    ExportarExcel() {
        window.open(this.urlExportarExcel, "_blank");

    }

    OpenModal() {
        this.modal.open();
    }

    modalClose() {
        this.modal.close();
        this.nuevoContratista = new ContratistaEntity();
        this.bandera=0;
    }

    GuardarContratista(): void {
        this.nuevoContratista.CliCod = this.userEmpresa.CodigoCliente;
        this.nuevoContratista.CiuCod = this.userEmpresa.Ciudad;
        this.nuevoContratista.RegCod=this.usuario.CodigoUsuario;        
        this.contratistasService.GuardarContratista(this.nuevoContratista).subscribe(
            guardo => {
                if (guardo) {
                    swal({
                        title: 'Registro exitoso',
                        text: "La información del contratista ha sido almacenada satisfactoriamente",
                        type: 'success'
                    });
                }
            },
            error => { this.handleError.redirectUrl(error); });
            this.modalClose();
    }

    ConsultarContratista(ruc: string): any {
        this.bandera=0;
        this.datosContratista = new BuscaContratista();
        this.datosContratista.RucContratista = ruc;
        this.datosContratista.CiuCod = this.userEmpresa.Ciudad;
        this.contratistasService.BuscarContratista(this.datosContratista).subscribe(contratista => {
            this.nuevoContratista = contratista;               
            if (this.nuevoContratista.CodigoContratista == null || this.nuevoContratista.CodigoContratista == undefined||this.nuevoContratista.CodigoContratista == 0) {
                this.bandera=1; 
                this.nuevoContratista.RucContratista = ruc;
            }                        
        }, error => this.handleError.redirectUrl(error));

        

    }

    VerAdjuntosMovimientos(contrato:ContratosEntity){
        this.adjuntos=[];
          this.datosBusqueda.CodigoCliente=this.userEmpresa.CodigoCliente;
          this.datosBusqueda.CodigoCiudad=this.userEmpresa.Ciudad;
          this.datosBusqueda.CodigoUnidad=contrato.Codigounidad;
          this.datosBusqueda.Carpeta=contrato.CodigoContrato;
        this.contratistasService.ConsultarAdjuntosContrato(this.datosBusqueda).subscribe(data => {
            this.adjuntos = data;
            console.log(data);
            console.log(this.adjuntos);
            this.showLoader = "";
          if(this.adjuntos.length!=0){
            jQuery('#myModal').modal('show');
          }
          else{
            this.showLoader = "";
            swal({
                title: 'Sin adjuntos',
                text: 'El contrsto no posee documentos',
                type: 'error',
                confirmButtonColor: '#A14950',
                confirmButtonText: 'Aceptar'
            })
          }

        }, error => {
            this.showLoader = "";
            swal({
                title: 'Error al cargar los adjuntos',
                text: error,
                type: 'error',
                confirmButtonColor: '#A14950',
                confirmButtonText: 'Aceptar'
            })
        });
       
        //file.withCredentials = false;

    }
    descargar(archivo: Archivo) {
        console.log("1");
        this.contratistasService.getArchivo(archivo).subscribe(
            result => {
                var a = document.createElement("a");
                document.body.appendChild(a);
                a.className = "hidden"
                let fileBlob = result.blob();
                let blob = null;
                if (archivo.Extension.toUpperCase() == "PDF") {
                    blob = new Blob([fileBlob], {
                        type: 'application/pdf'
                    });
                }
                if (archivo.Extension.toUpperCase() == "JPG") {
                    blob = new Blob([fileBlob], {
                        type: 'image/jpg'
                    });
                }
                if (archivo.Extension.toUpperCase() == "PNG") {
                    blob = new Blob([fileBlob], {
                        type: 'image/png'
                    });
                }
                if (archivo.Extension.toUpperCase() == "XLSX" || archivo.Extension.toUpperCase() == "XLS") {
                    blob = new Blob([fileBlob], {
                        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                    });
                }
                if (archivo.Extension.toUpperCase() == "DOCX") {
                    blob = new Blob([fileBlob], {
                        type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
                    });
                }
                if (archivo.Extension.toUpperCase() == "MSG") {
                    blob = new Blob([fileBlob], {
                        type: 'application/ms-outlook'
                    });
                }
                if (archivo.Extension.toUpperCase() == "RAR") {
                    blob = new Blob([fileBlob], {
                        type: 'application/x-rar-compressed'
                    });
                }
                if (archivo.Extension.toUpperCase() == "ZIP") {
                    blob = new Blob([fileBlob], {
                        type: '	application/zip'
                    });
                }
                if (archivo.Extension.toUpperCase() == "TXT") {
                    blob = new Blob([fileBlob], {
                        type: '	application/text'
                    });
                }

                let url = window.URL.createObjectURL(blob);
                a.href = url;
                if (archivo.Extension.toUpperCase() == "PDF") {
                    a.download = archivo.Nombre;
                }
                if (archivo.Extension.toUpperCase() == "XLSX"||archivo.Extension.toUpperCase() == "XLS") {
                    a.download = archivo.Nombre;
                }
                if (archivo.Extension.toUpperCase() == "DOCX") {
                    a.download = archivo.Nombre;
                }
                if (archivo.Extension.toUpperCase() == "JPG") {
                    a.download = archivo.Nombre;
                }
                if (archivo.Extension.toUpperCase() == "PNG") {
                    a.download = archivo.Nombre;
                }
                if (archivo.Extension.toUpperCase() == "MSG") {
                    a.download = archivo.Nombre;
                }
                if (archivo.Extension.toUpperCase() == "RAR") {
                    a.download = archivo.Nombre;
                }
                if (archivo.Extension.toUpperCase() == "ZIP") {
                    a.download = archivo.Nombre;
                }

                if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                    if (archivo.Extension.toUpperCase() == "XLSX"||archivo.Extension.toUpperCase() == "XLS") {
                        window.navigator.msSaveOrOpenBlob(blob, archivo.Nombre + ".xlsx");
                    }
                    if (archivo.Extension.toUpperCase() == "PDF") {
                        window.navigator.msSaveOrOpenBlob(blob, archivo.Nombre + ".pdf");
                    }
                    if (archivo.Extension.toUpperCase() == "DOCX") {
                        window.navigator.msSaveOrOpenBlob(blob, archivo.Nombre + ".docx");
                    }
                    if (archivo.Extension.toUpperCase() == "JPG") {
                        window.navigator.msSaveOrOpenBlob(blob, archivo.Nombre + ".jpg");
                    }
                    if (archivo.Extension.toUpperCase() == "PNG") {
                        window.navigator.msSaveOrOpenBlob(blob, archivo.Nombre + ".png");
                    }
                    if (archivo.Extension.toUpperCase() == "MSG") {
                        window.navigator.msSaveOrOpenBlob(blob, archivo.Nombre + ".msg");
                    }
                    if (archivo.Extension.toUpperCase() == "RAR") {
                        window.navigator.msSaveOrOpenBlob(blob, archivo.Nombre + ".rar");
                    }
                    if (archivo.Extension.toUpperCase() == "ZIP") {
                        window.navigator.msSaveOrOpenBlob(blob, archivo.Nombre + ".zip");
                    }
                    console.log("2");
                }
                else {
                    a.click();
                    console.log("3");
                    window.URL.revokeObjectURL(url);
                }
                //this.showLoader = "";
            },
            error => {
                console.log(error);
            }
        );
    }
    cerraradjuntos(){

        jQuery('#myModal').modal('hide');  
    }
}


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/empresas/contratistas/contratistas.component.ts